// extracted by mini-css-extract-plugin
export default {"wrap":"Wr-z","fullWidth":"Xr-z","searchPlacement":"Yr-z","heading":"Zr-z","items":"_r-z","featureCss":"as-z","disabled":"bs-z","imgCss":"cs-z"};